import {
  FormControl,
  FormErrorMessage,
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
  useColorModeValue,
  Text,
} from '@chakra-ui/react';

import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError } from 'react-hook-form';

interface CheckboxProps extends ChakraCheckboxProps {
  name: string;
  label: string;
  error?: FieldError;
}

const CheckboxBase: ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> =
  ({ name, label, error = null, ...rest }, ref) => {
    const colorInput = useColorModeValue('gray.700', 'white');

    return (
      <FormControl isInvalid={!!error}>
        <ChakraCheckbox
          id={name}
          name={name}
          ref={ref}
          fontWeight="light"
          color={colorInput}
          size="lg"
          rounded="2xl"
          {...rest}
        >
          <Text fontSize="md">{label}</Text>
        </ChakraCheckbox>

        {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
      </FormControl>
    );
  };

export const Checkbox = forwardRef(CheckboxBase);
